// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats1 {
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 20px;
  }
  
  @media (max-width: 576px) {
    .stats1 {
      flex-direction: column;
    }
  }
  
  @media (max-width: 768px) {
    .stats1 {
      flex-direction: column;
    }
  }
  
  .statsItem1 {
    flex: 1 1;
    margin: 10px 0;
    padding: 15px;
    border-radius: 10px;
    cursor: pointer;
    background-color: white;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);
    border-left: 6px solid var(--primary-color);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .statsItem1:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
  }
  
  .statsTitle1 {
    font-size: 14px;
    font-weight: 700;
    border-bottom: 2px solid grey;
    margin-bottom: 10px;
  }
  
  .complete1 {
    color: rgb(10, 85, 10);
  }
  
  .progress1 {
    color: orange;
  }
  
  .pending1 {
    color: rgb(235, 55, 55);
  }
  
  .statsContainer1 {
    text-align: right;
    font-size: 12px;
  }
  
  /* Dashboard Content Container */
  
  .dashboard-content1 {
    display: flex;
    width: 100%;
    gap: 20px;
  }
  
  @media (max-width: 768px) {
    .dashboard-content1 {
      flex-wrap: wrap;
    }
    .chart-area1 {
      width: 100%;
    }
  }
  
  @media (max-width: 576px) {
    .dashboard-content1 {
      flex-wrap: wrap;
    }
    .chart-area1 {
      width: 100%;
    }
  }
  
  .dashboard-items {
    display: flex;
    flex: 1 1;
    gap: 20px;
  }
  
  /* Equal Size for Dashboard Items with different flex values */
  
  .arb-panel1 {
    flex: 1 1;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);
    border-left: 6px solid var(--primary-color);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    margin-top: 20px;
    flex-basis: 40%; /* Adjust the width */
    cursor: pointer;
  }
  
  .arb-panel1:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
  }
  
  .chart-area1 {
    flex: 1 1;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);
    border-left: 6px solid var(--primary-color);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    margin-top: 20px;
    flex-basis: 60%; /* Adjust the width */
    cursor: pointer;
  }
  
  .chart-area1:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
  }
  
  .arb-header1 {
    background-color: var(--primary-color);
    color: var(--secondary-color);
    padding: 5px;
    text-align: center;
    font-size: 20px;
    border-top-right-radius: 10px;
  }
  
  .arb-list1 {
    padding: 10px;
  }
  
  .list-item1 {
    border-bottom: 1px solid #da8c0e9d;
  }
  
  .list-item1 p {
    margin: 0;
    /* padding: 10px; */
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .list-item1:hover {
    background-color: var(--secondary-color);
    color: white;
  }
  
  .list-item1 span {
    background: white;
    border-radius: 50px;
    padding: 5px;
    color: var(--primary-color);
    font-size: 12px;
    font-weight: bold;
  }
  
  /* Chart Area */
  
  .chart-header1 {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 15px;
    border-bottom: 2px solid grey;
  }
  
  .chart-header1 h2 {
    margin: 0;
    font-size: 20px;
    text-align: center;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/dashboards/ArbitratorDashboard/ArbDashboardMain.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE,SAAO;IACP,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,uGAAuG;IACvG,2CAA2C;IAC3C,qDAAqD;EACvD;;EAEA;IACE,sBAAsB;IACtB,0EAA0E;EAC5E;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,gCAAgC;;EAEhC;IACE,aAAa;IACb,WAAW;IACX,SAAS;EACX;;EAEA;IACE;MACE,eAAe;IACjB;IACA;MACE,WAAW;IACb;EACF;;EAEA;IACE;MACE,eAAe;IACjB;IACA;MACE,WAAW;IACb;EACF;;EAEA;IACE,aAAa;IACb,SAAO;IACP,SAAS;EACX;;EAEA,8DAA8D;;EAE9D;IACE,SAAO;IACP,mBAAmB;IACnB,uBAAuB;IACvB,uGAAuG;IACvG,2CAA2C;IAC3C,qDAAqD;IACrD,gBAAgB;IAChB,eAAe,EAAE,qBAAqB;IACtC,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,0EAA0E;EAC5E;;EAEA;IACE,SAAO;IACP,mBAAmB;IACnB,uBAAuB;IACvB,uGAAuG;IACvG,2CAA2C;IAC3C,qDAAqD;IACrD,gBAAgB;IAChB,eAAe,EAAE,qBAAqB;IACtC,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,0EAA0E;EAC5E;;EAEA;IACE,sCAAsC;IACtC,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,wCAAwC;IACxC,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;EACnB;;EAEA,eAAe;;EAEf;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,SAAS;IACT,eAAe;IACf,kBAAkB;EACpB","sourcesContent":[".stats1 {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    gap: 20px;\n  }\n  \n  @media (max-width: 576px) {\n    .stats1 {\n      flex-direction: column;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .stats1 {\n      flex-direction: column;\n    }\n  }\n  \n  .statsItem1 {\n    flex: 1;\n    margin: 10px 0;\n    padding: 15px;\n    border-radius: 10px;\n    cursor: pointer;\n    background-color: white;\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);\n    border-left: 6px solid var(--primary-color);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .statsItem1:hover {\n    transform: scale(1.02);\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);\n  }\n  \n  .statsTitle1 {\n    font-size: 14px;\n    font-weight: 700;\n    border-bottom: 2px solid grey;\n    margin-bottom: 10px;\n  }\n  \n  .complete1 {\n    color: rgb(10, 85, 10);\n  }\n  \n  .progress1 {\n    color: orange;\n  }\n  \n  .pending1 {\n    color: rgb(235, 55, 55);\n  }\n  \n  .statsContainer1 {\n    text-align: right;\n    font-size: 12px;\n  }\n  \n  /* Dashboard Content Container */\n  \n  .dashboard-content1 {\n    display: flex;\n    width: 100%;\n    gap: 20px;\n  }\n  \n  @media (max-width: 768px) {\n    .dashboard-content1 {\n      flex-wrap: wrap;\n    }\n    .chart-area1 {\n      width: 100%;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .dashboard-content1 {\n      flex-wrap: wrap;\n    }\n    .chart-area1 {\n      width: 100%;\n    }\n  }\n  \n  .dashboard-items {\n    display: flex;\n    flex: 1;\n    gap: 20px;\n  }\n  \n  /* Equal Size for Dashboard Items with different flex values */\n  \n  .arb-panel1 {\n    flex: 1;\n    border-radius: 10px;\n    background-color: white;\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);\n    border-left: 6px solid var(--primary-color);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    margin-top: 20px;\n    flex-basis: 40%; /* Adjust the width */\n    cursor: pointer;\n  }\n  \n  .arb-panel1:hover {\n    transform: scale(1.02);\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);\n  }\n  \n  .chart-area1 {\n    flex: 1;\n    border-radius: 10px;\n    background-color: white;\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);\n    border-left: 6px solid var(--primary-color);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    margin-top: 20px;\n    flex-basis: 60%; /* Adjust the width */\n    cursor: pointer;\n  }\n  \n  .chart-area1:hover {\n    transform: scale(1.02);\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);\n  }\n  \n  .arb-header1 {\n    background-color: var(--primary-color);\n    color: var(--secondary-color);\n    padding: 5px;\n    text-align: center;\n    font-size: 20px;\n    border-top-right-radius: 10px;\n  }\n  \n  .arb-list1 {\n    padding: 10px;\n  }\n  \n  .list-item1 {\n    border-bottom: 1px solid #da8c0e9d;\n  }\n  \n  .list-item1 p {\n    margin: 0;\n    /* padding: 10px; */\n    font-size: 12px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .list-item1:hover {\n    background-color: var(--secondary-color);\n    color: white;\n  }\n  \n  .list-item1 span {\n    background: white;\n    border-radius: 50px;\n    padding: 5px;\n    color: var(--primary-color);\n    font-size: 12px;\n    font-weight: bold;\n  }\n  \n  /* Chart Area */\n  \n  .chart-header1 {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 15px;\n    border-bottom: 2px solid grey;\n  }\n  \n  .chart-header1 h2 {\n    margin: 0;\n    font-size: 20px;\n    text-align: center;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
